import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  LoadingController,
  ToastController,
} from '@ionic/angular';

import { ServiceCategory } from '../../../models';
import { ServiceDefinition } from '../../../models';
import { UserService } from '../../../services/user.service';
import { ServiceDefinitionService } from '../../../services/service-definition.service';
import { Utilities } from '../../../utilities/utilities';
import { List } from 'immutable';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { AlertService } from '../../../utilities/alert.service';
import { ToastService } from '../../../utilities/toast.service';
import { ServiceCategoryPickerComponent } from '../service-category-picker/service-category-picker.component';
import { Router, ActivatedRoute } from '@angular/router';

import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
declare var posthog: any;
@Component({
  selector: 'app-service-detail-form',
  templateUrl: './service-detail-form.component.html',
  styleUrls: ['./service-detail-form.component.scss'],
})
export class ServiceDetailFormComponent implements OnInit{

  public isLoading: boolean;

  public submitAttempt: boolean;

  public savingInProgress: boolean;

  @Input() serviceDetail: ServiceDefinition;

  @Input() salonServiceCategories: List<ServiceCategory>;
  public serviceDetailForm: UntypedFormGroup;

  // public serviceCategory: FormControl;

  public serviceName: UntypedFormControl;

  public price: UntypedFormControl;

  public bookback: UntypedFormControl;

  public startDuration: UntypedFormControl;

  public processDuration: UntypedFormControl;

  public finishDuration: UntypedFormControl;

  public clientBookable: UntypedFormControl;

  public timeSlots: List<{ label: string; value: number }>;

  public currency: string;

  currencyMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();

  constructor (
              //private viewCtrl: ViewController,
              //private navParams: NavParams,
              private userService: UserService,
              private alertCtrl: AlertController,
              private modalCtrl: ModalController,
              private serviceDefinitionService: ServiceDefinitionService,
              private formBuilder: UntypedFormBuilder,
              private actionSheetController: ActionSheetController,
              private loadingCtrl: LoadingController,
              private toastController: ToastController,  
              private readonly alertService: AlertService,
              private readonly toastService: ToastService,
              private route: ActivatedRoute) {
                this.isLoading = false;
                this.submitAttempt = false;
                this.savingInProgress = false;

    /*this.isLoading = false;
    this.submitAttempt = false;
    this.savingInProgress = false;
   // this.serviceDetail = route.snapshot.params.serviceDetail;
   // this.salonServiceCategories = route.snapshot.params.salonServiceCategories;
    /*this.route.params.subscribe({
      next: params => {
        this.serviceDetail = params.serviceDetail;
        this.salonServiceCategories = params.salonServiceCategories;

      }
    });*/
    //this.serviceDetail = this.navParams.get('service');
    //this.salonServiceCategories = this.navParams.get('salonServiceCategories');
    // this.serviceCategory = new FormControl(this.serviceDetail.getCategoryID(), Validators.required);
    /*this.serviceName = new FormControl(
      this.serviceDetail.getServiceName(),
      Validators.required
    );
    this.price = new FormControl(
      this.serviceDetail.getPrice(),
      Validators.required
    );
    this.bookback = new FormControl(
      this.serviceDetail.getProcessDuration() !== 0 &&
        this.serviceDetail.getFinishDuration() !== 0
    );
    this.startDuration = new FormControl(
      this.serviceDetail.getDuration(),
      Validators.required
    );
    this.processDuration = new FormControl(
      this.serviceDetail.getProcessDuration()
    );
    this.finishDuration = new FormControl(
      this.serviceDetail.getFinishDuration()
    );
    this.clientBookable = new FormControl(
      this.serviceDetail.isClientBookable()
    );
    this.timeSlots = List([]);
    this.currency = this.userService.getSalon()
      ? this.userService.getSalon().getCurrency()
      : '';
    this.currency = Utilities.decodeHTML(this.currency);

    for (let i = 15; i <= 720; i += 15) {
      const hour = Math.floor(i / 60);
      const minutes = i % 60;
      const label = `${(hour > 0) ? hour + ' hour' : ''}${(hour > 1) ? 's' : ''} ${(minutes > 0) ? minutes + ' mins' : ''}`;

      this.timeSlots = this.timeSlots.push({
        label: label,
        value: i

      });
    }

    this.serviceDetailForm = this.formBuilder.group({
      // serviceCategory: this.serviceCategory,
      serviceName: this.serviceName,
      price: this.price,
      bookback: this.bookback,
      startDuration: this.startDuration,
      processDuration: this.processDuration,
      finishDuration: this.finishDuration,
      clientBookable: this.clientBookable

    });

    this.mask = createNumberMask({
      prefix: this.currency,

      allowDecimal: true,
    }); */
  }

  public ngOnInit () {
    this.serviceName = new UntypedFormControl(
      this.serviceDetail.getServiceName(),
      Validators.required
    );
    this.price = new UntypedFormControl(
      this.serviceDetail.getPrice(),
      Validators.required
    );
    this.bookback = new UntypedFormControl(
      this.serviceDetail.getProcessDuration() !== 0 &&
        this.serviceDetail.getFinishDuration() !== 0
    );
    this.startDuration = new UntypedFormControl(
      this.serviceDetail.getDuration(),
      Validators.required
    );
    this.processDuration = new UntypedFormControl(
      this.serviceDetail.getProcessDuration()
    );
    this.finishDuration = new UntypedFormControl(
      this.serviceDetail.getFinishDuration()
    );
    this.clientBookable = new UntypedFormControl(
      this.serviceDetail.isClientBookable()
    );
    this.timeSlots = List([]);
    this.currency = this.userService.getSalon()
      ? this.userService.getSalon().getCurrency()
      : '';
    this.currency = Utilities.decodeHTML(this.currency);
    this.currencyMask = maskitoNumberOptionsGenerator({
      decimalZeroPadding: true,
      precision: 2,
      decimalSeparator: '.',
      thousandSeparator: ',',
      min: 0,
      prefix: this.currency,
    });

    for (let i = 15; i <= 720; i += 15) {
      const hour = Math.floor(i / 60);
      const minutes = i % 60;
      const label = `${(hour > 0) ? hour + ' hour' : ''}${(hour > 1) ? 's' : ''} ${(minutes > 0) ? minutes + ' mins' : ''}`;

      this.timeSlots = this.timeSlots.push({
        label: label,
        value: i

      });
    }

    this.serviceDetailForm = this.formBuilder.group({
      //serviceCategory: this.serviceCategory,
      serviceName: this.serviceName,
      price: this.price,
      bookback: this.bookback,
      startDuration: this.startDuration,
      processDuration: this.processDuration,
      finishDuration: this.finishDuration,
      clientBookable: this.clientBookable

    });

  }

  public onBookBackToggle($event) {
    if ($event.detail.checked) {
      this.serviceDetail = this.serviceDetail.setProcessDuration(15);
      this.serviceDetail = this.serviceDetail.setFinishDuration(15);
      this.processDuration.setValue(15);
      this.finishDuration.setValue(15);
    } else {
      this.serviceDetail = this.serviceDetail.setProcessDuration(0);
      this.serviceDetail = this.serviceDetail.setFinishDuration(0);
      this.processDuration.setValue(0);
      this.finishDuration.setValue(0);
    }
  }


  public isFormValid(): boolean {
    return (
      this.serviceDetailForm.valid &&
      this.serviceDetail.serviceCategory !== undefined
    );
  }

  public onServiceDetailFormSave() {
    this.submitAttempt = true;

    if (!this.isFormValid()) {
      return;
    }

    this.savingInProgress = true;
    // this.serviceDetail = this.serviceDetail.setCategoryID(this.serviceCategory.value);
    const price: number = Utilities.extractNumberFromString(this.price.value);

    this.serviceDetail = this.serviceDetail.setServiceName(this.serviceName.value);
    this.serviceDetail = this.serviceDetail.setPrice(price);
    this.serviceDetail = this.serviceDetail.setDuration(parseInt(this.startDuration.value, 10));

    if (this.bookback.value) {
      this.serviceDetail = this.serviceDetail.setProcessDuration(parseInt(this.processDuration.value, 10));
      this.serviceDetail = this.serviceDetail.setFinishDuration(parseInt(this.finishDuration.value, 10));
    } else {
      this.serviceDetail = this.serviceDetail.setProcessDuration(0);
      this.serviceDetail = this.serviceDetail.setFinishDuration(0);
    }

    this.serviceDetail = this.serviceDetail.setClientBookable(this.clientBookable.value);
    this.serviceDefinitionService.saveServiceDefinition(this.serviceDetail)
      .subscribe({
        next: (response: ServiceDefinition) => {
            this.savingInProgress = false;
            this.modalCtrl.dismiss(response);
          },
          error: (e) => {
            this.savingInProgress = false;
            this.alertService.presentErrorAlert();
          }
      });
  }

  public onDismiss () {
    this.modalCtrl.dismiss();
  }

  public async showServiceCategoryPicker () { 
    const modal = await this.modalCtrl.create({
    component: ServiceCategoryPickerComponent
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.serviceDetail = this.serviceDetail.setServiceCategory(data.data);
      }
    });

    return await modal.present();
  }

  public async onDeleteService () {

    const actionSheet = await this.actionSheetController.create({
      header: 'Are you sure you want to delete this service?',
      buttons: [
        {
          text: `Yes, delete this service`,
          icon: 'trash',
          role: 'destructive',
          cssClass: 'sm-error',
          handler: () => {

            actionSheet.dismiss().then(async () => {
                  const loader = await this.loadingCtrl.create({
                    spinner: 'crescent',
                  });

                  loader.present();

              this.serviceDefinitionService.deleteServiceDefinition(this.serviceDetail)
                .subscribe({
                  next: (success) => {
                  loader.dismiss().then(() => {
                    this.modalCtrl.dismiss(this.serviceDetail).then(() => {
                      this.toastService.presentSimpleToast(`Service has been deleted.`, 3000);         
                    });
                  });
                },
                error: (e) => {
                  loader.dismiss().then(() => {
                    this.alertService.presentErrorAlert();
                  });
                }

                });
            });

            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          }
        }
      ]
    });

    return await actionSheet.present();
  }



}
